import {determineIfTrainingIsWork} from "./determineIfTrainingIsWork"
import {determineIfCalendarDayIsLocked} from "./determineIfCalendarDayIsLocked"

export const countThresholdDays = (
  currentDate,
  jurisdictionName,
  travelDates
) => {
  // Determine if training is work based on jurisdiction
  const trainingIsWork = determineIfTrainingIsWork(jurisdictionName)
  // Initialize a variable for counting work days
  let count = 0
  // Iterate over each day
  travelDates.forEach((day) => {
    // Determine if day type is work
    const isWork = day.type === "work"
    // Determined if the day is locked
    const isLocked = determineIfCalendarDayIsLocked(day.date)
    // Determine if training is counted as work for this jurisdiction
    const isWorkTraining = day.type === "training" && trainingIsWork
    /**
     * If the date is confirmed and not locked, and is work or is training at a jurisdiction
     * where training is counted as work, increment the work day count. */
    if ((day.confirmed || isLocked) && (isWork || isWorkTraining)) {
      count += 1
    }
  })
  // Return the work day count
  return count
}
